// app.js

"use strict";

window.debugEvent = false;

import angular from "angular";
import "@uirouter/angularjs";
import "oclazyload";
import "moment/locale/ru"

import ngAnimate from 'angular-animate';
import angularMoment from 'angular-moment';
import ngSanitize from 'angular-sanitize';
import { stateController } from "./components/desktop/desktop.module.state";


import "./components/components.module";
import "./components/elements/elements.module";
import "./components/desktop/desktop.module";

import { appRouting } from "./app.routing";
import { bxMenuProvider } from "./app.providers.bxmenu";
import { 
      applicantInfos,
      applicantTypes,
      applicantFiles,
      referenceEntity
} from "./app.constants";


import {
  bxDesktop,
  bxProfile,
  $script,
  ymapsLoader
} from "./app.factory"

import "./app.services";
import {
  fioFull,
  gender,
  printableDate
} from "./app.filters";

const MOETP_APP =  angular
  .module("moetpApp", [
    'ui.router',
    'oc.lazyLoad',
    'moetp.services',
    'moetp.desktop',
    
    'moetp.components',
    'moetp.formelements',


    ngAnimate,
    angularMoment,
    ngSanitize
  ])
  .config(appRouting)
  .provider('bxMenu',  bxMenuProvider)
  .constant('applicantInfos',applicantInfos)
  .constant('applicantTypes',applicantTypes)
  .constant('applicantFiles',applicantFiles)
  .constant('referenceEntity',referenceEntity)
  .controller('stateController',stateController)
  .factory('bxDesktop', bxDesktop)
  .factory('bxProfile', bxProfile)
  .factory('ymapsLoader', ymapsLoader)
  .factory('$script', $script)

  .filter('gender', gender)
  .filter('fioFull', fioFull)
  .filter('printableDate', printableDate)
  


  .run(["$locale", function ($locale) {
  $locale.NUMBER_FORMATS.GROUP_SEP = " ";
 // $locale.NUMBER_FORMATS.DECIMAL_SEP = ".";
}])
  .directive("disableAnimate", function ($animate) {
    return function (scope, element) {
          $animate.enabled(false, element);
      };
  })

  ;

export { MOETP_APP };



// WEBPACK FOOTER //
// ./src/app.js